import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";
import {useForm} from "react-hook-form";
import * as UserActions from "@commons/actions/user.action";
import {UpdateUserResult} from "@commons/actions/user.action";
import {toast} from "react-toastify";
import {UseFormReturn} from "react-hook-form/dist/types";
import React from "react";
import InputEx from "@components/wrapperComponents/InputEx";
import * as Validation from "@utilities/validationRules";

export type UserProfileFormData = Pick<UserCRUDRecord, 'userName' | 'codiceFiscale' | 'nome' | 'cognome' | 'email' | 'telefono' | 'cellulare' | 'emailNotificheWF'>

const _onSuccess = (payload: UpdateUserResult) => {
    toast('Profilo utente aggiornato!', {type: 'success'});
    if (payload.tokenVerificaEmail) {
        toast('Ti abbiamo inviato una nuova email!', {type: 'success'});
    }
}

export function useFormUserProfile(onSuccess: (payload: UpdateUserResult) => void = _onSuccess): {
    user: UserCRUDRecord | null,
    updateUser: (data: UserProfileFormData) => void,
    useFormReturn: UseFormReturn<UserProfileFormData, any>
} {
    const dispatch = useAppDispatch();
    const user: UserCRUDRecord | null = useAppSelector(selectUser);

    const defaultValues: UserProfileFormData = {
        userName: (user && user.userName) ? user.userName : '',
        codiceFiscale: (user && user.codiceFiscale) ? user.codiceFiscale : '',
        nome: (user && user.nome) ? user.nome : '',
        cognome: (user && user.cognome) ? user.cognome : '',
        email: (user && user.email) ? user.email : '',
        telefono: (user && user.telefono) ? user.telefono : '',
        cellulare: (user && user.cellulare) ? user.cellulare : '',
        emailNotificheWF: (user && user.emailNotificheWF) ? user.emailNotificheWF : '',
    }

    const r = useForm<UserProfileFormData>({mode: "onChange", defaultValues});
    const updateUser = (data: UserProfileFormData) => {
        dispatch(UserActions.updateUser({...data, idUser: user?.idUser})).then((res) => {
            if (res.type === UserActions.updateUser.fulfilled.type) {
                onSuccess(res.payload as UpdateUserResult);
            } else if (res.type === UserActions.updateUser.rejected.type) {
                toast(`Errore in aggiornamento profilo utente! ${res}`, {type: 'error'})
            }
        });
    };
    return {user, updateUser, useFormReturn: r};
}

export const UserForm: React.FC<{ form: UseFormReturn<UserProfileFormData, any> }> = ({form}) => {
    const {register, formState: {errors}} = form;
    return (<>
            <div className="inline-flex w-full gap-x-4">
                <div className="basis-1/2">
                    <InputEx type="text" label={'Username'} name="userName" register={register} disabled/>
                </div>

                <div className="basis-1/2">
                    <InputEx type="text" label={'Codice fiscale'} name="codiceFiscale" register={register} disabled/>
                </div>
            </div>
            <div className="inline-flex w-full gap-x-4">
                <div className="basis-1/2">
                    <InputEx type="text" label={'Nome'} name="nome" register={register} disabled/>
                </div>
                <div className="basis-1/2">
                    <InputEx type="text" label={'Cognome'} name="cognome" register={register} disabled/>
                </div>
            </div>
            <div className="inline-flex w-full gap-x-4">
                <div className="basis-1/2">
                    <InputEx type="email" label={'Email'} name="email" register={register} errors={errors} registerOptions={{...Validation.emailRequired}}/>
                </div>

                <div className="basis-1/2">
                    <InputEx type="email" label={'Email notifiche WF'} name="emailNotificheWF" register={register} errors={errors} registerOptions={{...Validation.email}}/>
                </div>
            </div>
            <div className="inline-flex w-full gap-x-4">
                <div className="basis-1/2">
                    <InputEx type="text" label={'Telefono fisso'} name="telefono" maxLength={15} minLength={10} register={register} registerOptions={{...Validation.telefono}}
                             errors={errors}/>
                </div>
                <div className="basis-1/2">
                    <InputEx type="text" label={'Telefono cellulare'} name="cellulare" maxLength={15} minLength={10} register={register}
                             registerOptions={{...Validation.telefono}}
                             errors={errors}/>
                </div>
            </div>
        </>
    )
}